/**
 * Monta il drawer mobile Kontatto dentro il contenitore dell'header stock.
 *
 * Perché a runtime e non in Liquid: il menu mobile lo monta
 * `sections/header.liquid` con `content_for 'block', type: '_header-menu'`, un
 * riferimento statico che non si può sostituire dal JSON, e quel block chiama a
 * sua volta lo snippet `header-drawer`. Cambiare drawer in Liquid vorrebbe dire
 * modificare uno dei due file stock, cosa che qui è esclusa: quindi il markup
 * arriva da una sezione nostra dentro l'header group, dorme in un <template> e
 * viene clonato al posto di quello di Horizon.
 *
 * Il contenitore `.header__drawer` porta `data-hydration-key`, quindi il tema lo
 * rigenera: `section-hydration.js` al primo caricamento e `morph.js` sugli
 * aggiornamenti parziali di sezione. Ogni volta che succede torna dentro il
 * drawer stock, per questo il montaggio è idempotente e riparte da un
 * MutationObserver invece di girare una volta sola.
 */

const TEMPLATE_ID = 'kontatto-mobile-drawer-template';
const HOST_SELECTOR = '.header__drawer';
const MOUNTED_SELECTOR = '.kontatto-drawer';

/**
 * Sostituisce il contenuto di ogni contenitore drawer con il nostro clone.
 * Non fa niente se il nostro è già dentro: è questo che evita il loop con
 * l'observer, che scatta anche per le mutazioni che causiamo noi.
 */
function mount() {
  const template = document.getElementById(TEMPLATE_ID);

  if (!(template instanceof HTMLTemplateElement)) return;

  for (const host of document.querySelectorAll(HOST_SELECTOR)) {
    if (host.querySelector(MOUNTED_SELECTOR)) continue;

    // replaceChildren porta via anche il <header-drawer> stock, così non
    // restano due componenti in ascolto sugli stessi eventi.
    host.replaceChildren(template.content.cloneNode(true));
  }
}

mount();

// Osserva solo #header-group: è il wrapper scritto da layout/theme.liquid:58,
// fuori dalle sezioni, quindi non viene sostituito quando l'header si rigenera.
// Osservare tutto il body costerebbe una callback per ogni mutazione di pagina.
const headerGroup = document.querySelector('#header-group');

if (headerGroup) {
  new MutationObserver(mount).observe(headerGroup, { childList: true, subtree: true });
}
